<template>
  <Multiselect
    id="defaultFlowForCompanies"
    :modelValue="flowStore.flowCompanies"
    :max-height="400"
    :options="searchCompany"
    :minChars="3"
    :searchable="true"
    :delay="500"
    object
    class="mt-1 block w-full rounded-md border-gray-300 shadow-xs focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
    inputType="search"
    mode="tags"
    autocomplete="off"
    @change="(e) => updateCompanies(e)"
  />
</template>

<script setup>
import Multiselect from '@vueform/multiselect'
import { useFlowStore } from '../../store/flowStore'
import tooPublishers from '../../api/tooPublishers'

const flowStore = useFlowStore()

const searchCompany = async (filter = '') => {
  const queryRes = await tooPublishers.getCompanies({
    filter: filter || '',
    size: 15,
  })
  return queryRes.data.map((company) => ({
    label: company.name,
    value: company.id,
  }))
}

const updateCompanies = (companies) => (flowStore.flowCompanies = companies)
</script>

<style scoped></style>
